import React from 'react';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Alert, AlertProps } from '@mantine/core';

const ErrorAlert: React.FC<AlertProps> = (props) => (
  <Alert
    mt="md"
    variant="light"
    color="red"
    title="Something went wrong"
    icon={<IconAlertTriangle />}
    {...props}
  />
);

export default ErrorAlert;
